module.exports = __webpack_public_path__ + "static/img/anquan.45048ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/anquan.png
// module id = NR+K
// module chunks = 0